/**
 * Service class for making HTTP requests
 */
export function HttpService() {
  /**
   * Make an HTTP request that expects a JSON response
   *
   * @param {*} url       The URL to make the request to
   * @param {*} options   options for the fetch function
   *
   * @returns {Promise}   A promise that resolves with the JSON response data, or rejects for any of these reasons:
   *                      1. The HTTP status code is not between 200-299
   *                      2. The response is not valid JSON
   *                      3. Network failures or anything that prevented the HTTP request from completing
   */
  function fetchJson(url, options = {}) {
    options.headers = { Accept: 'application/json', 'Content-Type': 'application/json' };

    return new Promise((resolve, reject) => {
      fetch(url, options)
        .then((response) => {
          if (response.ok && response.status !== 204) {
            response.json().then((data) => resolve(data));
          } else if (response.ok && response.status === 204) {
            resolve();
          } else {
            response.json().then((errorResponse) => {
              errorResponse.code = response.status;
              reject(errorResponse);
            });
          }
        })
        .catch((error) => reject(error));
    });
  }

  return {
    /**
     * Make a GET request to the specified URL
     *
     * @param {string} url  The URL to make the request to
     *
     * @returns {Promise} A Promise that resolves with the response data when successful, and rejects on failure
     */
    get: (url) => fetchJson(url, { method: 'GET' }),

    /**
     * Make a POST request to the specified URL
     *
     * @param {string} url  The URL to make the request to
     * @param {any} body    The request body
     *
     * @returns {Promise} A Promise that resolves with the response data when successful, and rejects on failure
     */
    post: (url, body) => fetchJson(url, { method: 'POST', body: JSON.stringify(body) }),
  };
}
